// | Multiset implemented using `Data.Map`.
// |
// | Loosely based on <https://hackage.haskell.org/package/multiset>.
import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMap from "../Data.Map/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return x; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return y; }
  $runtime.fail();
};
const toSet = dictOrd => {
  const $0 = Data$dSet.foldableSet.foldl(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf);
  return x => $0(Data$dMap.keys(x));
};
const toOccurArray = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const size = /* #__PURE__ */ (() => {
  const go = (z$p, m$p) => {
    if (m$p.tag === "Leaf") { return z$p; }
    if (m$p.tag === "Node") { return go(go(z$p, m$p._5) + m$p._4 | 0, m$p._6); }
    $runtime.fail();
  };
  return m => go(0, m);
})();
const singleton = x => Data$dMap$dInternal.$$$Map("Node", 1, 1, x, 1, Data$dMap$dInternal.Leaf, Data$dMap$dInternal.Leaf);
const showMultiSet = dictShow => {
  const show = Data$dShow.showArrayImpl(v => "(Tuple " + dictShow.show(v._1) + " " + Data$dShow.showIntImpl(v._2) + ")");
  return {show: x => "(fromOccurArray " + show(toOccurArray(x)) + ")"};
};
const semigroupMultiSet = dictOrd => {
  const compare = dictOrd.compare;
  return {append: v => v1 => Data$dMap$dInternal.unsafeUnionWith(compare, Data$dSemiring.intAdd, v, v1)};
};
const ordMultiSet = dictOrd => Data$dMap$dInternal.ordMap(dictOrd)(Data$dOrd.ordInt);
const occur = dictOrd => x => {
  const $0 = Data$dMap$dInternal.lookup(dictOrd)(x);
  return x$1 => {
    const $1 = $0(x$1);
    if ($1.tag === "Nothing") { return 0; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
};
const monoidMultiSet = dictOrd => {
  const compare = dictOrd.compare;
  const semigroupMultiSet1 = {append: v => v1 => Data$dMap$dInternal.unsafeUnionWith(compare, Data$dSemiring.intAdd, v, v1)};
  return {mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => semigroupMultiSet1};
};
const mapOccurences = dictOrd => f => v => Data$dMap$dInternal.mapMaybeWithKey(dictOrd)(k => n => {
  const n$p = f(k)(n);
  if (n$p > 0) { return Data$dMaybe.$Maybe("Just", n$p); }
  return Data$dMaybe.Nothing;
})(v);
const isEmpty = v => v.tag === "Leaf";
const intersection = dictOrd => {
  const compare = dictOrd.compare;
  return v => v1 => Data$dMap$dInternal.unsafeIntersectionWith(compare, min, v, v1);
};
const eqMultiSet = dictEq => Data$dMap$dInternal.eqMap(dictEq)(Data$dEq.eqInt);
const empty = Data$dMap$dInternal.Leaf;
const elems = /* #__PURE__ */ (() => {
  const $0 = Data$dArray.concatMap(v => Data$dArray.replicateImpl(v._2, v._1));
  return x => $0(toOccurArray(x));
})();
const distinctElems = x => Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr, Data$dMap.keys(x));
const alterCount = dictOrd => {
  const alter = Data$dMap$dInternal.alter(dictOrd);
  return f => x => alter(x$1 => {
    const $0 = f((() => {
      if (x$1.tag === "Just") { return x$1._1; }
      if (x$1.tag === "Nothing") { return 0; }
      $runtime.fail();
    })());
    if ($0 <= 0) { return Data$dMaybe.Nothing; }
    return Data$dMaybe.$Maybe("Just", $0);
  })(x);
};
const $$delete = dictOrd => alterCount(dictOrd)(v => 0);
const insertMany = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return x => howMany => alterCount1(v => v + howMany | 0)(x);
};
const deleteMany = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return x => n => {
    const $0 = -n;
    return alterCount1(v => v + $0 | 0)(x);
  };
};
const deleteOne = dictOrd => {
  const deleteMany1 = deleteMany(dictOrd);
  return x => deleteMany1(x)(1);
};
const restoreOrderingOccur = dictOrd => {
  const deleteMany1 = deleteMany(dictOrd);
  return ordering => items => {
    const v = Data$dFoldable.foldlArray(v => item => {
      const v1 = occur(dictOrd)(item)(v._2);
      if (v1 === 0) { return Data$dTuple.$Tuple(v._1, v._2); }
      return Data$dTuple.$Tuple(Data$dSemigroup.concatArray([Data$dTuple.$Tuple(item, v1)])(v._1), deleteMany1(item)(v1)(v._2));
    })(Data$dTuple.$Tuple([], items))(ordering);
    return Data$dSemigroup.concatArray(Data$dArray.reverse(v._1))(toOccurArray(v._2));
  };
};
const difference = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return orig => toRemove => Data$dFoldable.foldlArray(acc => v => {
    const $0 = -v._2;
    return alterCount1(v$1 => v$1 + $0 | 0)(v._1)(acc);
  })(orig)(toOccurArray(toRemove));
};
const fromOccurArray = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return Data$dFoldable.foldlArray(acc => v => {
    const $0 = v._2;
    return alterCount1(v$1 => v$1 + $0 | 0)(v._1)(acc);
  })(Data$dMap$dInternal.Leaf);
};
const insert = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return x => alterCount1(v => v + 1 | 0)(x);
};
const fromArray = dictOrd => {
  const alterCount1 = alterCount(dictOrd);
  return Data$dFoldable.foldlArray(acc => x => alterCount1(v => v + 1 | 0)(x)(acc))(Data$dMap$dInternal.Leaf);
};
export {
  alterCount,
  $$delete as delete,
  deleteMany,
  deleteOne,
  difference,
  distinctElems,
  elems,
  empty,
  eqMultiSet,
  fromArray,
  fromOccurArray,
  insert,
  insertMany,
  intersection,
  isEmpty,
  mapOccurences,
  min,
  monoidMultiSet,
  occur,
  ordMultiSet,
  restoreOrderingOccur,
  semigroupMultiSet,
  showMultiSet,
  singleton,
  size,
  toOccurArray,
  toSet
};
